import { ButtonUiState } from '@/components/Common/Button/ButtonUi';

export interface ContextualMenuUi {
  showEdit: boolean;
  showView: boolean;
  deleteDialog?: ActionDialog;
  duplicateDialog?: ActionDialog;
  open: boolean;
}
export const initialState: ContextualMenuUi = {
  showEdit: false,
  showView: false,
  open: false,
};

type ActionDialog = {
  cancelButton: ButtonUiState;
  confirmButton: ButtonUiState;
};
